<template>
  <div class="tips-info">
    <ParlayTable>
      <template v-slot:header>
        <span class="tips-info__header">Esto sería el resultado si sucediera lo que elegiste en el Simulador:</span>
      </template>
      <div class="tips-info__data">
        <div class="container-money">
          <div class="content money">
            <div>
              Apostando:
            </div>
            <div>
              <InputAmount
                :value="value"
                :section-name="'tips'"
                font-family="Roboto-Black"
                @input="$emit('input', $event)"
              />
            </div>
          </div>
          <div class="separator"></div>
        </div>
        <!--        <div class="container-risk">-->
        <!--          <div class="content risk">-->
        <!--            <div>Probabilidad:</div>-->
        <!--            <div>-->
        <!--              <div>{{ riskPercentage }} <span>%</span></div>-->
        <!--              <div>-->
        <!--                Probabilidad de ganar dinero:-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="separator"></div>-->
        <!--        </div>-->
        <div class="container-revenue">
          <div class="content revenue">
            <div>Tu monto final:</div>
            <div>
              <div>$ {{ finalAmount }}</div>
              <div>MXN</div>
            </div>
          </div>
          <div class="separator"></div>
        </div>
        <div class="container-lost">
          <div class="content lost">
            <div>{{ lostText }}</div>
            <div>
              <div>$ {{ (finalAmount - value).toFixed(2) }}</div>
              <div>MXN</div>
            </div>
          </div>
          <div class="separator last"></div>
        </div>
      </div>
    </ParlayTable>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'TipsSelectedInfo',
  components: {
    InputAmount: () => import('@/components/Form/InputAmount'),
    ParlayTable: () => import('@/components/Sections/GolTipster-v2/General/ParlayTipsTable'),
  },
  props: {
    tipsBets: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: 100,
    },
    riskPercentage: {
      type: [Number, String],
      default: 0,
    },
    finalAmount: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapState(['displayWidth']),
    totalProbability() {
      return this.tipsBets.reduce((accumulator, bet) => {
        let currentProbability = accumulator;
        const probActual = bet.prob_actual / 100;
        currentProbability = currentProbability ? currentProbability * probActual : currentProbability + probActual;
        return currentProbability;
      }, 0);
    },
    totalOdd() {
      return this.totalProbability <= 0.5
        ? 100 / this.totalProbability - 100
        : (100 * this.totalProbability) / (this.totalProbability - 1);
    },
    payout() {
      return this.totalOdd > 0
        ? (this.value * this.totalOdd) / 100 + this.value
        : (this.value * 100) / Math.abs(this.totalOdd) + this.value;
    },
    lostText() {
      if (this.displayWidth > 780) {
        return 'Pérdida / Ganancia:';
      }
      return 'Ganancia:';
    },
  },
};
</script>

<style scoped lang="scss">
$darkBlue: #132839;
.tips-info {
  font-size: 1rem;
  width: 100%;

  &__header {
    width: 100%;
    font-family: Roboto-Medium, sans-serif;
    font-size: 1.25em;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.1;

    @media screen and (max-width: 696px) {
      font-size: 0.9365em;
      padding: 0.6em 0.5em 0.6em;
    }
  }

  &__data {
    width: 100%;
    max-width: 54em;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-areas: unset;
    margin: 0.8em 0 1.2em;
    font-family: Roboto-Black, sans-serif;

    & > div {
      width: 100%;
      display: flex;
    }

    & div.content {
      width: 100%;
      display: flex;
      flex-direction: column;
      margin: 0 0.5em;
      color: #132839;

      & > div {
        &:first-child {
          font-family: Roboto-Medium, sans-serif;
          font-size: 1.18em;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 1.16;
          letter-spacing: -0.38px;
          text-align: center;
          color: #000;
        }

        &:last-child {
          color: $darkBlue;
        }
      }
    }

    & div.separator {
      height: 2.5em;
      border-right: 1px dashed #506270;
      margin-top: 0.8em;

      &.last {
        display: none;
      }
    }

    & div.money {
      align-items: center;

      & > div:last-child {
        margin-top: 1.2em;
      }
    }

    & div.risk {
      & > div {
        &:last-child {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          margin-top: 0.8em;

          & > div {
            align-self: center;
            &:first-child {
              font-size: 2em;
              font-weight: 900;
              font-stretch: normal;
              font-style: normal;
              line-height: 0.79;
              letter-spacing: -0.56px;
              margin-right: 0.5em;
              border-radius: 0.9em;
              background-color: #cbee6b;
              padding: 0.4em;
              white-space: nowrap;
              & > span {
                font-size: 1.625rem;
                font-weight: 500;
              }
            }
            &:last-child {
              font-family: Roboto-Regular, sans-serif;
              font-size: 1em;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 1;
              letter-spacing: -0.32px;
              color: black;
              text-align: left;
            }
          }
        }
      }
    }

    & div.revenue {
      & div {
        &:last-child {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          margin-top: 1.2em;

          & > div {
            &:first-child {
              font-size: 1.75em;
              font-weight: 900;
              font-stretch: normal;
              font-style: normal;
              line-height: 0.79;
              letter-spacing: -0.56px;
              margin-right: 0.4em;
              white-space: nowrap;
            }

            &:last-child {
              font-size: 0.81em;
              font-weight: bold;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.08;
              letter-spacing: normal;
            }
          }
        }
      }
    }

    & div.lost {
      align-items: center;

      & > div {
        &:last-child {
          display: flex;
          justify-content: center;
          align-items: flex-end;
          margin-top: 1em;
          border-radius: 12px;
          background-color: #cbee6b;
          padding: 0.7em 0.8em 0.6em;

          & > div {
            &:first-child {
              font-size: 1.75em;
              font-weight: 900;
              font-stretch: normal;
              font-style: normal;
              line-height: 0.79;
              letter-spacing: -0.56px;
              margin-right: 0.4em;
              white-space: nowrap;
            }

            &:last-child {
              font-size: 0.81em;
              font-weight: bold;
              font-stretch: normal;
              font-style: normal;
              line-height: 1.08;
              letter-spacing: normal;
            }
          }
        }
      }
    }

    @media screen and (max-width: 780px) {
      & div.risk {
        & > div:last-child {
          margin-top: 0.7em;
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;

          & > div {
            &:first-child {
              margin-right: 0;
            }

            &:last-child {
              text-align: center;
              margin-top: 0.5rem;
            }
          }
        }
      }
    }

    @media screen and (max-width: 690px) {
      grid-template-columns: 1fr;
      grid-template-areas:
        'lost'
        'money'
        'revenue';

      & div.container {
        &-money {
          grid-area: money;
        }
        &-risk {
          grid-area: risk;
        }
        &-revenue {
          grid-area: revenue;
        }
        &-lost {
          grid-area: lost;
        }
      }

      & div.content {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        border-bottom: dashed 1px #506270;
        margin-bottom: 0 !important;
        height: 4em;

        & div.money {
          padding-right: 0;
          & > div:last-child {
            margin-top: 0 !important;
          }
        }

        &.revenue {
          border-bottom: unset !important;
        }

        &.risk {
          justify-content: space-between;

          & > div:last-child {
            margin-top: 0 !important;
            font-size: 1.06rem;
            flex-direction: row;
            width: fit-content;

            & > div {
              &:first-child {
                font-size: 1.875rem;
                margin-right: 0.5em;
              }

              &:last-child {
                font-size: 0.9375rem;
                text-align: left;
              }
            }
          }
        }

        & > div {
          &:first-child {
            margin-right: 0.5em;

            @media screen and (max-width: 320px) {
              font-size: 1.06em;
            }
          }
          &:last-child {
            margin-top: 0;
          }
        }
      }

      & div.separator {
        display: none;
      }
    }
  }
}
</style>
